import Amplify ,{ Storage, Auth } from 'aws-amplify';
import awsmobile from '../../aws-exports';

Amplify.configure(awsmobile);
Amplify.configure({
    API:{
        endpoints: [
            {
                name: "Synthesis API",
                endpoint: process.env.REACT_APP_aws_apigateway_endpoint,
                region: "us-east-1",
                custom_header: async () => {
                    return { Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
                  }
            },
            {
                name: "Synthesis Elasticsearch",
                endpoint: process.env.REACT_APP_ELASTICBEHAVIOR,
                region: "us-east-1"
            }
        ]
    }
})

export const getPhotoCurrentUser = (username) => {
    return new Promise(
        function(resolve, reject){
            Storage.get(username)
            .then(result => resolve(result))
            .catch(err => reject(err));
        }
    );
}

export const getKeys = (path) => {
    return new Promise(
        function(resolve, reject){
            Storage.list(path).then(response => resolve(response)).catch(err =>reject(err));
        }
    );
}

export const getKeysProtected = (path) => {
    return new Promise(
        function(resolve, reject){
            Storage.list(path).then(response => resolve(response)).catch(err =>reject(err));
        }
    );
}

export const getUrlImage = (userId) =>{
    return new Promise(
        function(resolve, reject){
            Storage.get(userId)
            .then(result => resolve(result))
            .catch(err => reject(err));
        }
    );
}

export const getUrlIconSynthesis = (userId) =>{
    return new Promise(
        function(resolve, reject){
            Storage.get(userId)
            .then(result => resolve(result))
            .catch(err => reject(err));
        }
    );
}

